/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_ErrorInputs */

const en_us2_plan_error = /** @type {(inputs: Plan_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan could not be loaded.`)
};

const pt_br2_plan_error = /** @type {(inputs: Plan_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar seu plano.`)
};

const es_419_plan_error = /** @type {(inputs: Plan_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar tu plan.`)
};

const pt_pt2_plan_error = /** @type {(inputs: Plan_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o teu plano.`)
};

const fr_fr2_plan_error = /** @type {(inputs: Plan_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger ton programme.`)
};

const de_de2_plan_error = /** @type {(inputs: Plan_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Plan konnte nicht geladen werden.`)
};

const it_it2_plan_error = /** @type {(inputs: Plan_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile caricare la tua scheda.`)
};

/**
* | output |
* | --- |
* | "Your plan could not be loaded." |
*
* @param {Plan_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_error = /** @type {((inputs?: Plan_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_error(inputs)
	if (locale === "es-419") return es_419_plan_error(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_error(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_error(inputs)
	if (locale === "de-DE") return de_de2_plan_error(inputs)
	if (locale === "it-IT") return it_it2_plan_error(inputs)
	return en_us2_plan_error(inputs)
});
export { plan_error as "plan.error" }